import { Message } from "element-ui";
export default {
  //非空校验
  isDefine(str) {
    if ([null, undefined, '', 0, NaN].includes(str)) {
      return false
    }
    return true
  },
  formatDate(oDate) {
    var
      oYear = oDate.getFullYear(),
      oMonth = oDate.getMonth() + 1,
      oDay = oDate.getDate();
    if (oMonth < 10) {
      oMonth = "0" + oMonth;
    }
    if (oDay < 10) {
      oDay = "0" + oDay;
    }
    var oTime = oYear + String(oMonth) + String(oDay) //最后拼接时间
    return Number(oTime)
  },
  copyText(text) {
    var target = document.createElement("div");
    target.id = "tempTarget";
    target.style.opacity = "0";
    target.innerText = text;
    var range = document.createRange();
    var target2 = document.body.appendChild(target);
    try {
      var range = document.createRange();
      range.selectNode(target);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand("copy");
      window.getSelection().removeAllRanges();
      Message({
        message: '复制成功',
        type: 'success'
      });
    } catch (e) {
      Message.error("复制失败");
    }
    target.remove();
    target2.remove();
  }
}



// WEBPACK FOOTER //
// ./src/utils/utils.js